<template>
    <PageLayout content-class="p-0" :has-page-scroll="false">
        <template v-slot:content>
            <section
                v-if="isLoadError || isFormLoading || isSaveInProgress"
                class="card w-100 h-100 d-flex flex-column align-items-center justify-content-center"
            >
                <div class="d-flex flex-column align-items-start" v-if="isLoadError && !isFormLoading">
                    <h5 class="fw-bold">Error</h5>
                    <p class="font-size-xl mb-1">
                        <template v-if="referralId">
                            There was problem while loading the referral. Please try again.
                        </template>
                        <template else>
                            There was problem while generating the referral form. Please try again.
                        </template>
                    </p>
                    <span class="mb-2">
                        If the problem persists,
                        <!--<report-error-link>Click here</report-error-link>-->
                        Click here to report it.
                    </span>
                    <button class="btn btn-primary" @click="loadReferral()">Try Again</button>
                </div>
                <div v-if="!isLoadError && isFormLoading" class="d-flex flex-column">
                    <i class="fas fa-clipboard-list fa-7x text-primary animated flash infinite slow mb-2"></i>
                    <span class="font-size-xl">Loading Referral Form...</span>
                </div>
                <div v-if="isSaveInProgress" class="d-flex flex-column align-items-center">
                    <i class="far fa-save fa-7x text-primary animated flash infinite slow mb-2"></i>
                    <span class="font-size-xl text-center">Saving Referral...</span>
                </div>
            </section>

            <template v-if="!isLoadError && !isFormLoading && !isSaveInProgress">
                <div id="Homecare_New_Referral">
                    <div class="convert-header mb-1">
                        {{ `Edit Home Care Referral-${formatName(referral.firstName, referral.lastName)}` }}
                    </div>
                    <div class="card mx-2 mb-4">
                        <div class="card-body form-content p-3 mx-lg-6">
                            <div class="mb-3">
                                <ReferralSourceInformation
                                    :referral="referral"
                                    v-on:updateReferralSource="updateReferralSource"
                                    v-on:updateReferralDetails="updateReferralDetails"
                                    :referral-details-validation="referralDetailsValidation"
                                    :referral-source-validation="referralSourceValidation"
                                    ref="referralSource"
                                />
                            </div>
                            <div class="mb-3">
                                <DemographicsInformation
                                    :referral="referral"
                                    :accountId="externalReferralAccountId"
                                    :providerId="providerId"
                                    :branchId="branchId"
                                    :checkPhoneValidation="checkPhoneValidation"
                                    :isEdit="isCreate ? false : true"
                                    ref="demographic"
                                />
                            </div>
                            <div class="mb-3">
                                <ServicesRequired
                                    :referral="referral"
                                    :accountId="externalReferralAccountId"
                                    v-on:updateHasOtherServicesRequired="updateHasOtherServicesRequired"
                                    v-on:updateNonMedicalServicesRequiredCollection="
                                        updateNonMedicalServicesRequiredCollection
                                    "
                                    v-on:updateServicesRequiredCollection="updateServicesRequiredCollection"
                                />
                            </div>
                            <div class="mb-3">
                                <template v-if="!referral.isNonMedical">
                                    <CreateDmeNeeded v-if="isCreate" :referral="referral" />
                                    <EditDmeNeeded v-else :referral="referral" :patient-id="referral.id" />
                                </template>
                            </div>
                            <div class="mb-3">
                                <template v-if="!referral.isNonMedical">
                                    <CreatePhysician v-if="isCreate" :referral="referral" />
                                    <EditPhysician v-else :referral="referral" :referral-id="referral.id" />
                                </template>
                            </div>
                            <div class="mb-3">
                                <EmergencyContactsSection
                                    v-if="!isCreate"
                                    :referral="referral"
                                    :patient-id="referral.id"
                                    :application="referral.application"
                                    :account-id="referral.accountId"
                                    :patient-primary-address="referral.primaryAddress"
                                />

                                <FormSection
                                    v-else
                                    title="Emergency Contacts"
                                    :full-height="false"
                                    :application-id="referral.application"
                                >
                                    <template #content>
                                        <section class="d-flex flex-column px-3 py-2">
                                            <div class="form-group col-12">
                                                Emergency Contacts can be added to the referral after it has been
                                                created.
                                            </div>
                                        </section>
                                    </template>
                                </FormSection>
                            </div>
                            <div class="mb-3">
                                <ReferralComments :referral="referral" />
                            </div>
                        </div>
                    </div>

                    <footer
                        v-if="!isLoadError && !isFormLoading && !isSaveInProgress"
                        class="d-flex justify-content-center form-footer gap-2"
                    >
                        <button type="button" class="btn btn-primary me-2" @click="update()" v-if="!isCreate">
                            Save Referral
                        </button>
                        <button type="button" class="btn btn-primary me-2" @click="create()" v-if="isCreate">
                            Create Referral
                        </button>
                        <button class="btn btn-outline-primary me-2" @click="goToReferralList()">
                            View Referral List
                        </button>
                        <button class="btn btn-outline-primary" @click="goToReferralList(true)">Cancel</button>
                    </footer>
                </div>
            </template>
        </template>
    </PageLayout>
</template>

<style src="./CreateReferralHomeCare.scss"></style>
<script lang="ts" src="./CreateReferralHomeCare.ts"></script>
